import { FC } from 'react';
import { Disclosure } from '@headlessui/react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';

interface FaqModel {
  title: string;
  answer: string;
}

const FaqComponent: FC<FaqModel> = ({ title, answer }) => {
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full justify-between rounded-lg bg-black px-4 py-3 text-left text-sm font-medium text-white">
            <span>{title}</span>
            {open ? (
              <BsChevronDown className="my-auto text-xl" />
            ) : (
              <BsChevronUp className="my-auto text-xl" />
            )}
          </Disclosure.Button>
          <Disclosure.Panel className="px-4 py-3">{answer}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default FaqComponent;
